<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import { computed } from 'vue';

  import { useSnackbarStore } from '@/stores/snackbar.store';

  const store = useSnackbarStore();
  const { message, type } = storeToRefs(store);
  const { clearMessage } = store;
  const showSnackbar = computed({
    get: () => message.value?.length > 0,
    set: (value) => {
      if (!value) {
        clearMessage();
      }
    },
  });

  const color = computed(() => {
    switch (type.value) {
      case 'success':
        return 'green';
      case 'error':
        return 'red';
      case 'warning':
        return 'orange';
      default:
        return 'blue';
    }
  });
</script>

<template>
  <v-snackbar v-model="showSnackbar" :color="color" style="z-index: 999999999">
    <div v-html="message"></div>
    <template #actions>
      <v-btn icon="mdi-close" @click="showSnackbar = false"> </v-btn>
    </template>
  </v-snackbar>
</template>
